import { useTranslation } from "react-i18next";
import { BrowseGalleryRounded, OpenInNewRounded } from "@mui/icons-material";

import { Button } from "@fragments";
import Parser from "@helpers/parser";
import { useAuth } from "@contexts/AuthContext";
import { useCommunity } from "@contexts/CommunityContext";

/** Badge sutil para administradores visualizando conteúdo pré-lançamento. */
export function AdminPreviewBadge({ launchDate }) {
    const { t } = useTranslation("content");

    return (
        <div className="admin-preview-badge">
            <BrowseGalleryRounded fontSize="small" />
            <span>{t("banners.airsOn", { date: Parser.date.readable(launchDate) })}</span>
        </div>
    );
}

/** Banner para conteúdo agendado (usuário não tem acesso mas vai ser lançado). */
export function LaunchDateBanner({ content }) {
    const { t } = useTranslation("content");
    const displayDate = content.timestamps?.launch || content.availability?.available_at;

    return (
        <>
            <img src={content.banner} alt={content.name} className="content-banner" />
            <div className="launch-date-card">
                <BrowseGalleryRounded fontSize="medium" />
                <span>{t("banners.airsOnDay", { date: Parser.date.readable(displayDate) })}</span>
            </div>
        </>
    );
}

/** Paywall para conteúdo premium indisponível ao usuário atual. */
export function PrivateVideoBanner({ community, content }) {
    const { t } = useTranslation("content");
    const { community: currentCommunity } = useCommunity();
    const { user } = useAuth();

    const currentCommunityInfo = currentCommunity?.get(community);

    if (!currentCommunityInfo || !content) return null;

    const planWhichIsAvailable = currentCommunityInfo?.plans?.find(
        (p) => p.id == content.availability?.plans?.[0]
    );

    let checkoutLink = `https://pay.ginastee.com/${currentCommunityInfo?.checkout}?email=${user.email.address}&name=${user.username}`;

    if (planWhichIsAvailable) {
        checkoutLink += `&plan=${planWhichIsAvailable?.id}`;
    }

    if (user.phone?.number) {
        checkoutLink += `&phone=${user.phone.number?.replace("+55", "")}`;
    }

    if (user.document) {
        checkoutLink += `&document=${user.document}`;
    }

    return (
        <>
            <img src={content.banner} alt={content.name} className="content-banner" />

            <div className="request-upgrade-banner px-4 py-4">
                <small className="premium-message-text">{t("banners.premiumMessage")}</small>
                <img src={currentCommunityInfo?.banner} alt={currentCommunityInfo?.name} className="community-banner mt-2" />
                <h4 className="mb-1">{currentCommunityInfo?.name}</h4>
                <Button
                    text={t("banners.viewPlans")}
                    color="white"
                    tooltip={t("banners.viewPlansTooltip", { name: currentCommunityInfo?.name })}
                    startIcon={<OpenInNewRounded />}
                    onClick={() => (window.location.href = checkoutLink)}
                />
            </div>
        </>
    );
}
